module.exports = __webpack_public_path__ + "img/Telephone@2x.18fa26b2.png";